import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { MomentModule } from 'angular2-moment';

import { ChatMessageComponent } from './chat-message/chat-message.component';
import { ChatComponent } from './chat/chat.component';
import { ChatsComponent } from './chats.component';
import { ChatsRoutingModule } from './chats.routing.module';
import { ChatsService } from './shared/chats.service';

@NgModule({
  imports: [
    CommonModule,
    ChatsRoutingModule,
    MomentModule,
    FormsModule,
    InfiniteScrollModule
  ],
  providers: [
    ChatsService,
  ],
  declarations: [
    ChatsComponent,
    ChatMessageComponent,
    ChatComponent
  ],
  exports: [
    ChatsComponent,
    ChatComponent
  ]
})
export class ChatsModule { }



// WEBPACK FOOTER //
// /ng-app/src/app/chats/chats.module.ts